export const USER = 'user'
export const BUSINESS = 'business'
export const EMAIL = 'email'
export const RECIPIENT_GROUP = 'saved'
export const BRIEF = 'brief'
export type RecipientTypes = 'user' | 'business' | 'email' | 'saved' | 'brief'
